class EncrytionDecrytionService {
    static CHARS = "a1b2c3d4e5f6g7h8i9j0klmnopqrstuvwxyzABCDEFGHIJKLM";
  
    // Method to generate the encryption key
    static fetchKey() {
      let key = "";
      for (let i = 0; i < this.CHARS.length; i++) {
        if (i % 2 === 0) {
          key += this.CHARS.charAt(i);
        }
      }
  
      const now = new Date();
      const day = now.getDate();
      const strDay = (day < 10 ? "0" : "") + day;
  
      const month = now.getMonth() + 1;
      const strMonth = (month < 10 ? "0" : "") + month;
  
      return strDay + key.substring(0, 12) + strMonth;
    }
  
    // Method to generate the IV (Initialization Vector)
    static fetchIV() {
      let iv = "";
      for (let i = 0; i < this.CHARS.length; i++) {
        if (i % 2 === 0) {
          iv += this.CHARS.charAt(i);
        }
      }
      return iv.substring(0, 12);
    }
  
    // Helper method to convert a string to an ArrayBuffer
    static stringToArrayBuffer(str) {
      const encoder = new TextEncoder();
      return encoder.encode(str);
    }
  
    // Helper method to convert an ArrayBuffer to Base64
    static arrayBufferToBase64(buffer) {
      const bytes = new Uint8Array(buffer);
      let binary = "";
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    }
  
    // Helper method to convert Base64 to ArrayBuffer
    static base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }
  
    // Method to import the AES key
    static async importKey() {
      const keyData = this.stringToArrayBuffer(this.fetchKey());
      return await window.crypto.subtle.importKey(
        "raw",
        keyData,
        { name: "AES-GCM" },
        false,
        ["encrypt", "decrypt"]
      );
    }
  
    // Method to encrypt data
    static async encrypt(plaintext) {
      const key = await this.importKey();
      const iv = this.stringToArrayBuffer(this.fetchIV());
      const encoder = new TextEncoder();
      const plaintextBytes = encoder.encode(plaintext);
  
      const ciphertextBuffer = await window.crypto.subtle.encrypt(
        {
          name: "AES-GCM",
          iv: iv,
          tagLength: 128,
        },
        key,
        plaintextBytes
      );
  
      // Return the encrypted data as Base64
      return this.arrayBufferToBase64(ciphertextBuffer);
    }
  
    // Method to decrypt data
    static async decrypt(ciphertextBase64) {
      const key = await this.importKey();
      const iv = this.stringToArrayBuffer(this.fetchIV());
      const ciphertextBuffer = this.base64ToArrayBuffer(ciphertextBase64);
  
      const plaintextBuffer = await window.crypto.subtle.decrypt(
        {
          name: "AES-GCM",
          iv: iv,
          tagLength: 128,
        },
        key,
        ciphertextBuffer
      );
  
      const decoder = new TextDecoder();
      return decoder.decode(plaintextBuffer);
    }
  }
  
  export default EncrytionDecrytionService;
  